module.exports = __webpack_public_path__ + "static/offers-92688d5a7407c0844825708bc9336982.png";